var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticStyle:{"font-size":"17px"}},[_vm._v(" "+_vm._s(_vm.toptime)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }